module.exports = __webpack_public_path__ + "static/media/Playlist 3.80304c7a.svg";